import React from 'react'
import "./footer.css"

function Footer() {
  return (
    <div className='footer'>  
       © 2021 Tariq_Rasheed
    </div>
  )
}

export default Footer